<template>
  <div>
    <div :class="{ 'summar-box-2': isUi2 }">
      <b-row class="demo-box" align-h="center">
        <b-col align-self="center" xl="10" lg="10" md="10" sm="12">
          <div class="card card-margin">
            <h3 class="list-name-container">Media Type Info</h3>
            <b-row>
              <b-col class="list-name-input-container">
                <b-form-select
                  v-model="order.MediaTypeName"
                  style="margin-top: 10px"
                >
                  <option v-for="item in options" :value="item.value">
                    {{ item.text }}
                  </option>
                </b-form-select>
                <m-error-text
                  :val="order.MediaTypeName"
                  :immediate="showError"
                  :rules="['require']"
                />
              </b-col>
            </b-row>
            <template v-if="order.MediaTypeName === 'facebook'">
              <b-row class="item list-media-input-container">
                <b-col lg="5" class="item-title ">Share Account ID(*): </b-col>
                <b-col lg="7">
                  <b-input
                    :value="order.ShareAccountId"
                    @input.native="updateMediaInfo('ShareAccountId', $event)"
                    size="sm"
                  ></b-input>
                  <m-error-text
                    :val="order.ShareAccountId"
                    :immediate="showError"
                    :rules="['require']"
                  />
                </b-col> </b-row
              ><b-row class="item list-name-input-container">
                <b-col lg="5" class="item-title">Package Name(*): </b-col>
                <b-col lg="7">
                  <b-input
                    :value="order.PackageName"
                    @input.native="updateMediaInfo('PackageName', $event)"
                    size="sm"
                  ></b-input>
                  <m-error-text
                    :val="order.PackageName"
                    :immediate="showError"
                    :rules="['require']"
                  />
                </b-col>
              </b-row>
            </template>
            <template v-if="order.MediaTypeName === 'twitter'">
              <b-row class="item list-media-input-container">
                <b-col lg="5" class="item-title">Tenant ID(*): </b-col>
                <b-col lg="7">
                  <b-input
                    :value="order.TenantId"
                    @input.native="updateMediaInfo('TenantId', $event)"
                    size="sm"
                  ></b-input>
                  <m-error-text
                    :val="order.TenantId"
                    :immediate="showError"
                    :rules="['require']"
                  />
                </b-col> </b-row
              ><b-row class="item list-media-input-container">
                <b-col lg="5" class="item-title">Destination ID(*): </b-col>
                <b-col lg="7">
                  <b-input
                    :value="order.DestinationId"
                    @input.native="updateMediaInfo('DestinationId', $event)"
                    size="sm"
                  ></b-input>
                  <m-error-text
                    :val="order.DestinationId"
                    :immediate="showError"
                    :rules="['require']"
                  />
                </b-col> </b-row
              ><b-row class="item list-name-input-container">
                <b-col lg="5" class="item-title"
                  >Destination Account ID(*):
                </b-col>
                <b-col lg="7">
                  <b-input
                    :value="order.DestinationAccountId"
                    @input.native="
                      updateMediaInfo('DestinationAccountId', $event)
                    "
                    size="sm"
                  ></b-input>
                  <m-error-text
                    :val="order.DestinationAccountId"
                    :immediate="showError"
                    :rules="['require']"
                  />
                </b-col>
              </b-row>
            </template>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import MErrorText from "@/components/common/MerrorText";
export default {
  components: {
    MErrorText,
  },
  props: {
    isUi2: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: [
        { text: "Please Select Media Type", value: "" },
        { text: "Facebook", value: "facebook" },
        { text: "Twitter", value: "twitter" },
      ],
    };
  },
  computed: {
    showError() {
      return this.$store.getters["summary/showError"];
    },
    order() {
      return this.$store.state.order;
    },
  },
  methods: {
    updateMediaInfo(key, e) {
      this.$store.commit("order/saveKey", [key, e.target.value]);
    },
  },
};
</script>

<style scoped lang="scss">
.title {
  display: flex;
  justify-content: space-between;
}
.item {
  padding-top: 8px;
  font-size: 13px;
}
.item-title {
  padding-right: 0;
  margin-right: 0;
}
.demo-box {
  margin-left: 8px;
  margin-bottom: 0px;
  margin-top: 8px;
}
.card-margin {
  margin: 10px auto;
}
.code-style {
  margin-bottom: 8px;
  margin-left: 16px;
  margin-right: 45px;
}
.list-name-container {
  margin-top: 16px;
  margin-left: 16px;
  font-weight: bold;
}
.list-name-input-container {
  margin-bottom: 16px;
  margin-left: 16px;
  margin-right: 16px;
}
.list-media-input-container {
  margin-left: 16px;
  margin-right: 16px;
}

</style>



// WEBPACK FOOTER //
// src/components/summary/MMediaTypeInfo.vue